// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { login, isAuthenticated } from '../../utils/adminAuth';
import '../../assets/css/admin-dashboard.css';

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (isAuthenticated()) {
            history.push('/adm-gsconnect');
        }
    }, [history]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (login(username, password)) {
            setTimeout(() => {
                setLoading(false);
                history.push('/adm-gsconnect');
            }, 300);
        } else {
            setLoading(false);
            setError('Credenciais inválidas. Use admin/admin');
        }
    };

    return (
        <div className="login-page">
            <Container>
                <Row className="justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                    <Col xs={12} sm={8} md={6} lg={4}>
                        <Card className="login-card">
                            <Card.Body className="p-4">
                                <div className="text-center mb-4">
                                    <h2 className="login-title">gsConnect</h2>
                                    <p className="login-subtitle">Admin Dashboard</p>
                                </div>
                                
                                {error && (
                                    <Alert variant="danger" className="mb-3">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuário</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Digite seu usuário"
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)}
                                            required
                                            autoFocus
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4">
                                        <Form.Label>Senha</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Digite sua senha"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </Form.Group>

                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className="w-100"
                                        disabled={loading}
                                    >
                                        {loading ? 'Entrando...' : 'Entrar'}
                                    </Button>
                                </Form>

                                <div className="text-center mt-3">
                                    <small className="text-muted">
                                        Use: <strong>admin</strong> / <strong>admin</strong>
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default LoginPage;

